import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(1)">
      <path
        stroke="#919499"
        d="M6.692 35.385c1.32-6.154 4.183-9.231 8.592-9.231.746 1.85 1.987 2.728 3.724 2.636 1.572.013 2.781-.746 3.628-2.276 1.84.071 7.19.864 8.672 8.87"
      />
      <circle cx={19} cy={20} r={19.5} stroke="#979797" />
      <path stroke="#919499" strokeLinecap="round" d="M15.923 25.692v1" />
      <path
        stroke="#919499"
        d="M25.154 20c.985-.613 1.496-1.227 1.533-1.844.036-.616-.107-1.027-.429-1.233M12.846 20c-.985-.613-1.496-1.227-1.533-1.844-.036-.616.107-1.027.429-1.233"
      />
      <path
        stroke="#919499"
        d="M18.926 26.153c-2.965.045-6.122-3.078-6.08-5.278a80.832 80.832 0 0 0 0-3.744c.506-1.204 1.247-1.886 2.223-2.045 1.464-.237 3.555.37 4.95-.72a25.676 25.676 0 0 0 2.36-2.058c1.781 1.347 2.697 2.598 2.748 3.753.076 1.733-.029 3.138-.077 5.166-.047 2.028-3.158 4.882-6.124 4.926z"
      />
      <path stroke="#919499" strokeLinecap="round" d="M22.077 25.692v1" />
      <path
        stroke="#919499"
        d="M25.032 20c1.04-1.695 1.592-3.689 1.658-5.982.066-2.294-1.252-3.66-3.956-4.102-.994-1.944-2.986-2.614-5.976-2.008-2.99.606-4.784 2.284-5.382 5.036-.264 2.378.236 4.406 1.502 6.085"
      />
    </g>
  </svg>
);
const Memo = memo(SvgAvatar);
export default Memo;
